import { t } from 'i18next';

export enum ImageType {
  VMDK = 'VMDK',
  DOCKER = 'DOCKER',
}

export const getImageTypeLabel = (imageType: ImageType): string => {
  const labels = {
    [ImageType.VMDK]: t('vmdk'),
    [ImageType.DOCKER]: t('docker'),
  };

  return labels[imageType] || imageType;
};
